module.exports = __webpack_public_path__ + "img/JIMNY.6f3c5732.6f3c5732.png";